// extracted by mini-css-extract-plugin
export default {"error_page":"ErorrPage_error_page__XUsQC","main":"ErorrPage_main__4DW8f","title":"ErorrPage_title__SbaJT","description":"ErorrPage_description__N2a7a"};